/* eslint-disable no-unused-expressions */

import { createGlobalStyle } from 'styled-components'
import Colors from 'styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
  zIndexes,
} from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'

const GlobalStyle = createGlobalStyle`
  .ant-switch {
    min-width: 35px;
    height: 14px;
    background-color: ${Colors.gray9};

    &::before,
    &::after {
      top: 50%;
      left: -5px;
      width: 20px;
      height: 20px;
      transform: translateY(-50%);
    }
  }
  .ant-select {
    width: 100%;
    color: ${Colors.black};
  }
  .ant-select-sm .ant-select-selection--single {
    height: 26px;
  }
  .ant-select-sm .ant-select-selection__rendered {
    margin: 0 6px;
    line-height: 26px;
  }
  .ant-select-selection {
    width: 100%;
    border: 1px solid ${Colors.grayB};
    border-radius: ${borderRadius}px;

    &:hover {
      border-color: ${Colors.green};
    }
  }
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-color: ${Colors.green};
  }
 .ant-select-dropdown-menu-item:hover {
    background-color: ${Colors.grayF};
 }
 .ant-select-dropdown-menu-item-active {
    background-color: ${Colors.lightgreen};
 }
 .ant-select-arrow::before {
    font-family: 'Font Awesome\ 5 Free' !important;
    font-weight: 900;
    content: "\f0d7";
    color: ${Colors.green};
 }
  .ant-select-selection-selected-value {
    padding-right: ${spacing.small_3}px;
  }
  .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    box-shadow: none;
  }
  .ant-select-lg {
    height: 40px;
    font-size: 14px;

    .ant-select-selection--single {
      height: 100%;
    }
  }
 .ant-message-notice-content {
    background: ${Colors.pink};
 }
  .ant-switch-checked {
    background-color: rgba(96, 223, 82, 0.5);

    &::before,
    &::after {
      margin-left: 24px;
      background-color: ${Colors.green};
    }
  }
  .ant-checkbox-wrapper {
    display: table;
  }
  .ant-radio-group {
   display: block;
 }
  .ant-checkbox {
    display: table-cell;
    vertical-align: top;
    padding-top: 1px;
  }
  .ant-checkbox-checked&::after {
    animation: none;
  }
  .ant-checkbox-inner {
    width: 20px;
    height: 20px;
    border: 1px solid ${Colors.grayB};
    border-radius: ${borderRadius}px;

    &::after {
      width: 7px;
      height: 12px;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: ${Colors.green};
    border-color: ${Colors.green};
  }
  .ant-checkbox:hover::after,
  .ant-checkbox-wrapper:hover .ant-checkbox&::after {
    visibility: hidden;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: ${Colors.green};
  }
  .ant-checkbox-wrapper + span,
  .ant-checkbox + span {
    display: table-cell;
    padding-top: 1px;
    padding-right: 0;
    color: ${Colors.black};
    vertical-align: top;
    line-height: 1.3;
    ${mediaMax.phone`
      font-size: 16px;
    `}
  }
  .ant-radio {
    float: left;
  }
  .ant-radio-checked::after {
    border: 1px solid ${Colors.green};
    animation: none;
  }
  .ant-radio-inner {
    width: 20px;
    height: 20px;
    border-color: ${Colors.grayB};

    &::after {
      top: 4px;
      left: 4px;
      width: 10px;
      height: 10px;
      background-color: ${Colors.green};
      border-radius: 10px;
    }
  }
  .ant-radio-checked .ant-radio-inner {
    border: 1px solid ${Colors.green};
  }
  span.ant-radio + * {
    float: left;
    padding-top: 3px;
    padding-right: 0;
    padding-left: 28px;
    margin-top: -5px;
    margin-left: -20px;
    width: 100%;
    color: ${Colors.black};
    text-align: left;
  ${mediaMax.phone`
    font-size: 16px;
    margin-top: -5px;
  `}
  }
  .ant-radio-wrapper {
    display: inline-block;
    width: 100%;
    margin-right: 0;
    white-space: normal;
  }
  .ant-radio-wrapper:hover .ant-radio .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-focused .ant-radio-inner {
    border-color: ${Colors.green};
  }
  .ant-input {
  color: ${Colors.black};
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ", "Meiryo", verdana, Osaka, "ＭＳ Ｐゴシック", "MS PGothic", Sans-Serif;
  font-size: ${fontSize.small_3}px;
  border-radius: ${borderRadius}px;
  border: 1px solid ${Colors.grayB};
  resize: none;

    &:hover {
      border-color: ${Colors.green};
    }

    &:focus {
      border-color: ${Colors.green};
      box-shadow: none;
    }

  ${mediaMax.phone`
    font-size: ${fontSize.medium}px;
  `}
  }
  .ant-input-lg {
    height: 40px;
  }
 .ant-input-sm {
    height: 26px;
  }
  textarea.ant-input {
    padding: ${spacing.small_2}px;
  }
  .anticon {
    margin-right: 4px;
    font-size: 16px;
    font-family: 'Font Awesome\ 5 Free';
    font-weight: 900;
  }
  .ant-message-warning .anticon,
  .anticon-exclamation-circle {
    color: ${Colors.red};
  }
  .anticon-exclamation-circle:before {
    content: "\f06a";
  }
  .anticon-check-circle {
    color: ${Colors.green};
  }
  .anticon-check-circle:before {
    content: "\f058";
  }
  .ant-tooltip {
    font-size: ${fontSize.small}px;
    color: ${Colors.black};
    line-height: 1.454;
    z-index: ${zIndexes.baloon};
  }
  .ant-tooltip-inner {
    width: 100%;
    max-width: 330px;
    padding: ${spacing.medium}px;
    color: ${Colors.white};
    font-size: ${fontSize.small_2}px;
    background-color: #4b4b4b;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  }
  .ant-tooltip-placement-top .ant-tooltip-arrow,
  .ant-tooltip-placement-topLeft .ant-tooltip-arrow,
  .ant-tooltip-placement-topRight .ant-tooltip-arrow {
    border-top-color: ${Colors.white};
  }
  .ant-tooltip-placement-right .ant-tooltip-arrow,
  .ant-tooltip-placement-rightTop .ant-tooltip-arrow,
  .ant-tooltip-placement-rightBottom .ant-tooltip-arrow {
    border-right-color: ${Colors.white};
  }
  .ant-tooltip-placement-left .ant-tooltip-arrow,
  .ant-tooltip-placement-leftTop .ant-tooltip-arrow,
  .ant-tooltip-placement-leftBottom .ant-tooltip-arrow {
    border-left-color: ${Colors.white};
  }
  .ant-tooltip-placement-bottom .ant-tooltip-arrow,
  .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
  .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
    border-bottom-color: ${Colors.white};
  }
  .ant-fullcalendar-selected-day .ant-fullcalendar-value,
  .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
    background: ${Colors.green};
  }
  .ant-fullcalendar-today .ant-fullcalendar-value,
  .ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
    box-shadow: none;
  }
  .ant-fullcalendar-value:hover {
    background: ${Colors.lightgreen};
  }
  .ant-fullcalendar-header {
    background-color: ${Colors.white};
  }
  .ant-fullcalendar-header .ant-select {
    width: 68px;
  }
  .ant-fullcalendar-header .ant-radio-group {
    display: inline-block;
    vertical-align: top;
  }
  .ant-fullcalendar {
    background-color: ${Colors.white};
  }
  .ant-radio-button-wrapper-checked:first-child {
    border-color: ${Colors.green};
  }
  .ant-radio-button-wrapper-checked {
    color: ${Colors.green};
    border-color: ${Colors.green};
    &:hover {
      color: ${Colors.green};
    }
  }
  .ant-radio-button-wrapper:hover,
  .ant-radio-button-wrapper-focused {
    color: ${Colors.green};
  }
  .ant-radio-group-small .ant-radio-button-wrapper {
    height: 26px;
  }
  .ant-select-dropdown {
    z-index: ${zIndexes.select};
  }
  .ant-progress-circle-path {
    stroke: ${Colors.green};
  }
  .ant-progress-circle-trail {
    stroke: ${Colors.grayD};
  }
  .ant-progress-circle .ant-progress-text {
    transform: translateY(-35%);
    font-weight: bold;
  }
`

export default GlobalStyle
